/*
Copyright (c) 2011 Damien Antipa, http://www.nethead.at/, http://damien.antipa.at

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
/*
 * jQuery Plugin: Confirmation Dialog
 *
 * Requirements: jQuery 1.6.4, Bootstrap 1.3.0
 * http://jquery.com/
 * http://twitter.github.com/bootstrap/
 *
 * This Plugin can be used for anchors, to show a confirmation popup before redirecting to the link.
 *
 * #NETSAPIENS: modified for "click-to-call"
 */
(function($){
	$.fn.extend({
		confirmCall: function(options) {
			var defaults = {
				message: '<strong>' + _('Are you sure') + '</strong>',
				dialog: '<div id="confirm-call" class="popover">' +
							'<div class="arrow"></div>' +
							'<div class="popover-inner">' +
							  	'<div class="popover-content">' +
							  		'<p class="note"></p>' +
									'<p class="button-group"><a href="javascript:void(0)" class="col-md-1 btn btn-success"></a><a href="javascript:void(0)" class="btn btn-default col-md-1"></a></p>' +
							  	'</div>' +
							'</div>' +
						'</div>',
				cancelButton: _('Cancel')
			};
			var options =  $.extend(defaults, options);

			return this.each(function() {
				var o = options;
				var $elem = $(this);

				$elem.on('click', function(e) {
					e.preventDefault();
					if(!$('#confirm-call').length) {

						var offset = $elem.offset();
						var $dialog = $(o.dialog).appendTo('body');

						var x;
						if(offset.left > $dialog.width()) {
							//dialog can be left
							x = e.pageX - $dialog.width() - 20;
							$dialog.addClass('left');
						} else {
							x = e.pageX;
							$dialog.addClass('right');
						}
						var y = e.pageY - $dialog.height() / 2 - $elem.innerHeight() / 2 - 20;


						$dialog.css({
							display: 'block',
							position: 'absolute',
							top: y + 'px',
							left: x + 'px'
						});

						$dialog.find('p.button-group').css({
							marginTop: '5px',
							textAlign: 'right'
						});

						$dialog.find('a.btn').css({
							marginLeft: '3px'
						});

						log('o.message length');
						log(o.message.length);
						log(o.message);

						//prevents 10 digit numbers from truncating
						if (o.message.length > 14) {
							log('message length is greater than 14');
							$dialog.find('p.note').html('<h4>' + o.message + '</h4>');
						}

						else
							$dialog.find('p.note').html('<h3>' + o.message + '</h3>');

						$dialog.find('a.btn').eq(0).text($elem.attr("rel")).on('click', function(e) {
							if (typeof $elem.attr("auto") != 'undefined' && $elem.attr("auto") =="yes")
								clickToDial($elem.attr("uid"),$elem.text(),$elem.attr("dest"),null, true );
							else
								clickToDial($elem.attr("uid"),$elem.text(),$elem.attr("dest"));
							$dialog.remove();
						});

						$dialog.find('a.btn').eq(1).text(o.cancelButton).on('click', function(e) {
							$dialog.remove();
						});

						$dialog.on('mouseleave', function() {
							$dialog.fadeOut('slow', function() {
								$dialog.remove();
							});
						});
					}
				});
			});
		}
	});
})(jQuery);
